<template>
  <div class="ws-de-center">
    <ws-de-center-filter @change="onFilter" :filter.sync="filter" :is-enabled.sync="isFilterEnabled" ref="filter" />
    <section class="ws-de-center__content">
      <ws-list-view class="ws-de-center__list"
                    :class="{ 'is-pending':isPending, 'is-loading':isFindPending }"
                    :data="list"
                    :header="false"
                    :detailed="false">
        <template slot="empty" v-if="isFilterEnabled">
          {{$t('Результатов, подходящих под выбранные фильтры не найдено.')}} <a href="" @click.prevent="disableFilters()">{{$t('Отключить фильтры')}}</a>
        </template>
        <template slot-scope="props" class="ws-de-center__item">
          <ws-list-view-item-column>
            <header class="ws-de-center__item-header">
              <div class="ws-de-center__item-title" :style="{'border-left-color': props.row.color }" >
                <h2 class="is-size-3 has-text-weight-bold">
                  <router-link :to="`/de-center/${props.row.guid}`">
                    <ws-icon
                      v-if="!props.row.visible"
                      name="minus-circle"
                      width="12"
                      height="12"
                      class="minus-circle-ico"
                    />
                    <span class="has-text-primary" v-text="props.row.name.translate.ru"></span>
                  </router-link>
                  <router-link class="ws-de-center__item-header-link"
                               :to="`/demo-exams/?de_center_guid=${props.row.guid}&day_cm1.from=${getCurrentYear}-01-01&day_cm1.till=${getCurrentYear}-12-31`">
                    <b-tooltip :label="$t('Перейти к списку экзаменов')"
                               type="is-dark">
                      <ws-icon
                              class="ws-button__icon is-position-left"
                              name="list"
                              color="#1c3b8d"
                              width="24"
                              height="24"
                      />
                    </b-tooltip>
                  </router-link>
                  <button class="ws-button button is-text ws-de-center__item-header-link" @click="copyInfoToClipboard(props)">
                    <b-tooltip :label="$t('Скопировать данные о ЦПДЭ в буфер обмена')"
                               type="is-dark">
                      <ws-icon
                            class="ws-button__icon"
                            name="copy"
                            color="#1c3b8d"
                            width="16"
                            height="24"
                      />
                    </b-tooltip>
                  </button>
                </h2>
                <address>
                  <span v-if="props.row.address.locality && props.row.address.locality.title && props.row.address.locality.title.display">{{ props.row.address.locality.title.display }} &nbsp;</span>
                  <span v-if="props.row.address">{{ props.row.address.address.translate.ru }}</span>
                </address>
              </div>
              <div class="ws-de-center__item-meta">
                <ws-icon
                  class="ws-button__icon is-position-left"
                  name="geo-marker"
                  color="#6D9AE8"
                  width="12"
                  height="16"
                />
                <span class="ws-button__text has-text-info" v-text="props.row.address.region.title.display"></span>
              </div>
            </header>
          </ws-list-view-item-column>
        </template>
        <template slot="details" slot-scope="props">
          <ws-de-center-accred-comps-table :data="props.row.accred_comps" :de-center-guid="props.row.guid" />
        </template>
      </ws-list-view>
    </section>
    <footer class="ws-de-center__footer">
      <ws-pagination
        @change="onPageChange"
        :align="'right'"
        :totalItems="pagination.total"
        :itemsPerPage="pagination.per_page"
        :disabled="isPending"
        :currentIndex="pagination.current_page - 1">
      </ws-pagination>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import listMixin from '@/mixins/list.mixin'
import clipboardMixin from '@/mixins/clipboard.mixin'

export default {
  name: 'WsDeCenterList',
  mixins: [listMixin, clipboardMixin],
  data () {
    return {
      ready: 0
    }
  },
  watch: {
    ready (value) {
      if (value > 0) {
        this._fetch()
      }
    }
  },
  computed: {
    ...mapState('de-centers', {
      isFindPending: 'isFindPending',
      pagination: 'pagination'
    }),
    ...mapGetters('de-centers', {
      list: 'list'
    }),
    getCurrentYear () {
      return new Date().getFullYear()
    }
  },
  methods: {
    ...mapActions('de-centers', ['find']),
    ...mapMutations('de-centers', ['clearAll']),
    async _fetch () {
      this.clearAll()
      await this.find({ query: { k: this.keyword, page: this.page, per_page: this.per_page, ...this.filter } })
    },
    copyInfoToClipboard (props) {
      const link = `Наименование: ${props.row.name.translate.ru} \nРегион: ${props.row.address.region.title.display}`
      this.copyToClipboard(link)
      this.$buefy.toast.open({
        message: `Информация о ЦПДЭ успешно скопирована`,
        type: 'is-success'
      })
    }
  },
  created () {
    const unwatchFilter = this.$watch('filter', function () {
      this.ready++
      unwatchFilter()
    })
  }
}
</script>
<style scoped>
.minus-circle-ico {
  margin: -3px 5px 0 0;
}
</style>
